// --- Dependencies -------------------------------------------------------------------------------
// --- Our Modules --------------------------------------------------------------------------------
import Skeleton from "@/UI/atoms/Skeleton";
import "./styles.css";

// --- Constants ----------------------------------------------------------------------------------

/** Products, categories, discounts, branches, staff, days left — the most the overview ever shows. */
const TILE_COUNT = 6;

// --- Logic --------------------------------------------------------------------------------------

/**
 * Follows the overview's own order and borrows its `home-section` / `home-tiles` containers, so the
 * gaps and the tile grid come from one definition and the real content drops into place without the
 * page shifting under the reader.
 */
export default function HomeScreenLoader() {
    return (
        <div className="home-screen">
            <div className="home-screen-content">
                <Skeleton className="home-loader-hero" />

                <section className="home-section">
                    <Skeleton className="home-loader-title" />
                    <div className="home-tiles">
                        {Array.from({ length: TILE_COUNT }).map((_, i) => (
                            <Skeleton key={i} className="home-loader-tile" />
                        ))}
                    </div>
                </section>

                <section className="home-section">
                    <Skeleton className="home-loader-title" />
                    <Skeleton className="home-loader-alert" />
                </section>
            </div>
        </div>
    );
}
